import * as React from "react";
import type { SVGProps } from "react";
const SvgAttachment = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M17.92 6.856a4.4 4.4 0 0 0-6.315-.32L8.182 9.731a1 1 0 0 1-1.364-1.462l3.422-3.195a6.401 6.401 0 0 1 8.894 9.206l-6.927 6.927a4.536 4.536 0 0 1-6.414-6.414l6.75-6.75a2.768 2.768 0 1 1 3.914 3.914l-6.25 6.25-.707.707L8.086 17.5l.707-.707 6.25-6.25a.768.768 0 0 0-1.086-1.086l-6.75 6.75a2.536 2.536 0 0 0 3.586 3.586l6.927-6.927a4.4 4.4 0 0 0 .2-6.01"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgAttachment;
